import React from 'react';
import { XIcon, CheckIcon, ScaleIcon } from 'lucide-react';
import { costRows } from '../data/comparisons';
export function CostComparisonSection() {
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="costos-title" data-id="element-41" data-mp="3hcpddnvp5gk0">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-42" data-mp="33hdjtjta1w4o">
        <div className="max-w-2xl" data-id="element-43" data-mp="38dkicrjcg5cl">
          <ScaleIcon className="h-8 w-8 text-petrol" aria-hidden="true" data-id="element-44" data-mp="38em2rmm9246z" />
          <h2 id="costos-title" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-45" data-mp="3w59dsgrgp9xr">
            Lo que cuesta no tenerlo
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-body" data-id="element-46" data-mp="3mdvarz0axrzv">
            No tener un sistema no es gratis. Tiene un costo real: en tiempo, en salud y en calidad de
            vida.
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-2xl border border-beige-deep" data-id="element-47" data-mp="ivlgp7ctnzlu">
          <div className="grid grid-cols-2" data-id="element-48" data-mp="nq7tneyjy081">
            <p className="bg-beige px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-body sm:px-7 sm:text-sm" data-id="element-49" data-mp="3gqths43ip3us">
              Sin MegaPack
            </p>
            <p className="bg-sage-soft px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-sage-deep sm:px-7 sm:text-sm" data-id="element-50" data-mp="3pjn06ae9gjcv">
              Con MegaPack
            </p>
          </div>
          <ul data-id="element-51" data-mp="3cgfppyi8ilw">
            {costRows.map((row, index) => <li key={row.without} className={`grid grid-cols-2 border-t border-beige-deep ${index % 2 === 1 ? 'bg-cream' : 'bg-white'}`} data-id="element-52" data-mp="3alra1o0y8d2" data-mpi={index}>
                <div className="flex gap-3 px-5 py-5 sm:px-7" data-id="element-53" data-mp="casc68m1yam9">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-hover" aria-hidden="true" data-id="element-54" data-mp="8c1d3vy10iwi" />
                  <span className="text-sm leading-relaxed text-body-muted sm:text-base" data-id="element-55" data-mp="2e500clvarxa5">
                    {row.without}
                  </span>
                </div>
                <div className="flex gap-3 border-l border-beige-deep px-5 py-5 sm:px-7" data-id="element-56" data-mp="d31unbl2tlyw">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-57" data-mp="i0tkm025uy0g" />
                  <span className="text-sm font-medium leading-relaxed text-petrol sm:text-base" data-id="element-58" data-mp="mzwr7oxshcaj">
                    {row.with}
                  </span>
                </div>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-12 max-w-prose text-center font-display text-2xl font-extrabold leading-snug text-petrol sm:text-3xl" data-id="element-59" data-mp="w0l7kqannoql">
          La pregunta no es si podés permitirte el MegaPack. La pregunta es cuánto más tiempo podés
          permitirte <span className="text-cta-hover" data-id="element-60" data-mp="1apr426i3z0us">no tenerlo</span>.
        </p>
      </div>
    </section>;
}